export default function MiniCardLoader() {
    return (
        <>
            <div className="row ms-lg-1 me-lg-3 placeholder-glow">
                <div className="card  p-3 ">
                    <div className="row">
                        <div className="col-4">
                            <div className="placeholder" style={{
                                height: '50px',
                                width: '50px',
                            }}>

                            </div>
                        </div>
                        <div className="col-8 mt-1">
                            <p className="placeholder placeholder-sm col-3"></p><br />
                            <p className="placeholder placeholder-xs col-8"></p>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}